module.exports = __webpack_public_path__ + "static/media/pdf.64c9ade9.svg";